/**
 * Returns the proper index of a capture given the user's current pagination settings
 * @param {Object} props container object
 * @param {Number} props.captureNum capture number present in url params
 * @param {Number} props.pageLimit number of captures displayed per page
 * @param {Number} props.page current page of captures displayed
 * @param {String} props.currentView optional: current view (list, single, grid)
 * @returns index of the selected capture
 */
export const getViolationIndex = (props) => {
  try {
    if (props && typeof props.captureNum === 'string') { props.captureNum = parseInt(props.captureNum) }

    const { captureNum, pageLimit, page, currentView = null } = props

    if (currentView === 'list') { return captureNum }
    if (typeof captureNum === 'undefined' || typeof captureNum !== 'number') { return null }
    if (captureNum <= 0) { return 0 }
    if (pageLimit == null || page == null) { return captureNum }

    if (currentView === 'single') {
      return ((captureNum - 1) - (parseInt(pageLimit) * (Math.floor((captureNum - 1) / pageLimit))))
    }

    return captureNum - (parseInt(pageLimit) * (parseInt(page) - 1))
  } catch (err) {
    console.error(err)
    return null
  }
}
